import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}
const routes = [
  {
    path: '/hb2026',
    name: 'PC',
    component: () => import('@/views/PC.vue')
  },
  {
    path: '/hb2026/mobile',
    name: 'Mobile',
    component: () => import('@/views/Mobile.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
